interface InlineEditButtonProps {
  onClick?: () => void;
  className?: string;
}

export const InlineEditButton = ({ onClick, className }: InlineEditButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={`bg-os-brand flex h-10 shrink-0 items-center justify-center rounded-[34px] px-3 ${className ?? ""}`}
  >
    <span className="w-[47px] text-center text-sm font-bold text-white">Edit</span>
  </button>
);
